<template>
  <div>
    <div v-if="error" class="error">{{ error }}</div>
    <div v-else class="feed">
      <v-layout wrap>
        <template v-for="item in feed.items">
          <v-flex xs12 sm6 md4 lg4 class="pa-1" :key="item.guid">
            <v-card style="height: 100%"
              ><v-card-text>{{ item.title }}</v-card-text>
              <v-card-text>
                <v-layout>
                  <v-flex class="caption grey--text"
                    >{{ item.creator }}
                    <div>{{ item.pubDate | DateFormat('DD MMM YYYY HH:mm') }}</div>
                  </v-flex>
                  <v-flex class="text-xs-right"
                    ><v-btn
                      :href="item.link"
                      target="_blank"
                      small
                      depressed
                      color="primary"
                      class="ma-0"
                      >Read more</v-btn
                    ></v-flex
                  >
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
    </div>
  </div>
</template>

<script>
import RSSParser from 'rss-parser'
export default {
  components: {},
  props: {
    feedUrl: String,
    name: String,
    limit: Number,
    loadMore: Boolean
  },
  data() {
    return {
      loading: true,
      error: '',
      feed: {}
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    feedUrl() {
      this.fetchData()
    },
    limit(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getArticles()
      }
    }
  },
  methods: {
    async fetchData() {
      this.error = ''
      this.loading = true
      this.feed = {}
      try {
        const data = await fetch(this.feedUrl)
        if (data.ok) {
          const text = await data.text()
          const parser = new RSSParser()
          parser.parseString(text, (err, parsed) => {
            this.loading = false
            if (err) {
              this.error = `Error occured while parsing RSS Feed ${err.toString()}`
            } else {
              this.feed = parsed
            }
          })
        } else {
          this.error = 'Error occured while fetching the feed'
          this.loading = false
        }
      } catch (e) {
        if (e.toString() === 'TypeError: Failed to fetch') {
          this.error = 'Error due to CORS policy'
        } else {
          this.error = e.toString()
        }
        this.loading = false
      }
    },
    getArticles() {
      if (this.feed.items && this.feed.items) {
        return this.feed.items.slice(0, this.limit)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/partner/Feed.vue